/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InactiveCoverageDetection
 */
export interface InactiveCoverageDetection {
    /**
     * 
     */
    reason_code: InactiveCoverageDetectionReasonCodeEnum;
    /**
     * 
     */
    message: string;
}


/**
 * @export
 */
export const InactiveCoverageDetectionReasonCodeEnum = {
    NotLawfullyPresent: 'not_lawfully_present',
    Incarcerated: 'incarcerated',
    Deported: 'deported',
} as const;
export type InactiveCoverageDetectionReasonCodeEnum = typeof InactiveCoverageDetectionReasonCodeEnum[keyof typeof InactiveCoverageDetectionReasonCodeEnum];


/**
 * Check if a given object implements the InactiveCoverageDetection interface.
 */
export function instanceOfInactiveCoverageDetection(value: object): value is InactiveCoverageDetection {
    if (!('reason_code' in value) || value['reason_code'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function InactiveCoverageDetectionFromJSON(json: any): InactiveCoverageDetection {
    return InactiveCoverageDetectionFromJSONTyped(json, false);
}

export function InactiveCoverageDetectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InactiveCoverageDetection {
    if (json == null) {
        return json;
    }
    return {
        
        'reason_code': json['reason_code'],
        'message': json['message'],
    };
}

export function InactiveCoverageDetectionToJSON(json: any): InactiveCoverageDetection {
    return InactiveCoverageDetectionToJSONTyped(json, false);
}

export function InactiveCoverageDetectionToJSONTyped(value?: InactiveCoverageDetection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason_code': value['reason_code'],
        'message': value['message'],
    };
}

